import { isDraft, produce as immerProduce } from 'immer';
export function produce(base, recipe) {
  if (isDraft(base)) {
    recipe(base);
    return base;
  } else {
    return immerProduce(base, recipe);
  }
}